// src/pages/landing/LandingPage.js
import React from 'react';
import Navbar from '../../components/layout/navbar/Navbar';
import Header from './components/Header';
import About from './components/About';
import Footer from './components/Footer';

const LandingPage = () => {
  return (
    <div className="landing-page">
      <Navbar />
      <Header />
      <About />
      <Footer />
    </div>
  );
};

export default LandingPage;